import { c as _c } from "react/compiler-runtime";
import { ChevronDownIcon } from '@systemeio/ui/icons';
import { useState } from 'react';
import { MenuItemType, SingleItemDropdownInterface, SingleItemHrefInterface } from 'shared/components/header/types/menu-interface';
import { checkNestedIsActive } from 'shared/components/header/utils/check-nested-is-active';
import { checkNestedRendered } from 'shared/components/header/utils/check-nested-rendered';
import { isFlatMenuItem } from 'shared/components/header/utils/is-flat-menu-item';
import LinkWithoutPrefetch from 'shared/components/link-without-prefetch';
const SideMenuItem = t0 => {
  const $ = _c(2);
  const {
    item
  } = t0;
  let t1;
  if ($[0] !== item) {
    t1 = isFlatMenuItem(item) ? <SideMenuItemFlat {...item} /> : <SideMenuDropdown {...item} />;
    $[0] = item;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
export default SideMenuItem;
export function SideMenuItemFlat(item) {
  const $ = _c(14);
  if (!item.shouldRender) {
    return null;
  }
  let t0;
  if ($[0] !== item.href || $[1] !== item.isActive) {
    t0 = item.isActive(item.href);
    $[0] = item.href;
    $[1] = item.isActive;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const isActive = t0;
  const t1 = `flex items-center gap-4 ${isActive && "[&>svg]:fill-brand-primary"} [&>svg]:w-[24px]`;
  let t2;
  if ($[3] !== item.mobileIconRenderer) {
    t2 = item.mobileIconRenderer && item.mobileIconRenderer();
    $[3] = item.mobileIconRenderer;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const t3 = `${isActive ? "text-brand-primary" : "text-text-primary"} inline-flex grow items-center text-lg font-bold tracking-wide`;
  let t4;
  if ($[5] !== item.href || $[6] !== item.name || $[7] !== item.target || $[8] !== t3) {
    t4 = <LinkWithoutPrefetch className={t3} href={item.href} target={item.target}>{item.name}</LinkWithoutPrefetch>;
    $[5] = item.href;
    $[6] = item.name;
    $[7] = item.target;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t1 || $[11] !== t2 || $[12] !== t4) {
    t5 = <div className="group relative inline-block transition-all"><div className={t1}>{t2}{t4}</div></div>;
    $[10] = t1;
    $[11] = t2;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
}
function SideMenuDropdown(item) {
  const $ = _c(21);
  let t0;
  if ($[0] !== item) {
    t0 = checkNestedIsActive(item);
    $[0] = item;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const isActive = t0;
  const [open, setOpen] = useState(false);
  const dropdownItems = item.dropdownItems;
  if (!checkNestedRendered(item.dropdownItems)) {
    return null;
  }
  const t1 = `flex cursor-pointer items-center gap-4 ${isActive && "[&>svg]:fill-brand-primary"} [&>svg]:w-[24px]`;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => setOpen(_temp);
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== item.mobileIconRenderer) {
    t3 = item.mobileIconRenderer && item.mobileIconRenderer();
    $[3] = item.mobileIconRenderer;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const t4 = `${isActive ? "text-brand-primary" : "text-text-primary"} inline-flex grow items-center text-lg font-bold tracking-wide`;
  const t5 = `ml-auto self-center transition-transform ${open && "rotate-180"}`;
  let t6;
  if ($[5] !== t5) {
    t6 = <ChevronDownIcon className={t5} width={15} height={5} />;
    $[5] = t5;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== item.name || $[8] !== t4 || $[9] !== t6) {
    t7 = <div className={t4}>{item.name}{t6}</div>;
    $[7] = item.name;
    $[8] = t4;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t1 || $[12] !== t3 || $[13] !== t7) {
    t8 = <div className={t1} onClick={t2}>{t3}{t7}</div>;
    $[11] = t1;
    $[12] = t3;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== dropdownItems || $[16] !== open) {
    t9 = open && <SideMenuDropdownPanel dropdownItems={dropdownItems} />;
    $[15] = dropdownItems;
    $[16] = open;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t8 || $[19] !== t9) {
    t10 = <div>{t8}{t9}</div>;
    $[18] = t8;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  return t10;
}
function _temp(prev) {
  return !prev;
}
const SideMenuDropdownPanel = t0 => {
  const $ = _c(4);
  const {
    dropdownItems
  } = t0;
  let t1;
  if ($[0] !== dropdownItems) {
    t1 = dropdownItems.map(_temp2);
    $[0] = dropdownItems;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <div className="flex flex-col gap-2 whitespace-nowrap pl-10 pt-2 text-sm">{t1}</div>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};
const SideSubMenu = item => {
  const $ = _c(27);
  const [open, setOpen] = useState(false);
  let dropdownItems;
  let t0;
  let t1;
  let t2;
  let t3;
  let t4;
  if ($[0] !== item) {
    t4 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const isActive = checkNestedIsActive(item);
      dropdownItems = item.dropdownItems;
      if (!checkNestedRendered(item.dropdownItems)) {
        t4 = null;
        break bb0;
      }
      t1 = `flex cursor-pointer items-center gap-4 ${isActive && "[&>svg]:fill-brand-primary"} [&>svg]:w-[24px]`;
      if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = () => setOpen(_temp3);
        $[7] = t2;
      } else {
        t2 = $[7];
      }
      if ($[8] !== item.mobileIconRenderer) {
        t3 = item.mobileIconRenderer && item.mobileIconRenderer();
        $[8] = item.mobileIconRenderer;
        $[9] = t3;
      } else {
        t3 = $[9];
      }
      t0 = getSubItemClass(isActive);
    }
    $[0] = item;
    $[1] = dropdownItems;
    $[2] = t0;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
  } else {
    dropdownItems = $[1];
    t0 = $[2];
    t1 = $[3];
    t2 = $[4];
    t3 = $[5];
    t4 = $[6];
  }
  if (t4 !== Symbol.for("react.early_return_sentinel")) {
    return t4;
  }
  const t5 = `ml-auto self-center transition-transform ${open && "rotate-180"}`;
  let t6;
  if ($[10] !== t5) {
    t6 = <ChevronDownIcon className={t5} width={15} height={5} />;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== item.name || $[13] !== t0 || $[14] !== t6) {
    t7 = <div className={t0}>{item.name}{t6}</div>;
    $[12] = item.name;
    $[13] = t0;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t1 || $[17] !== t2 || $[18] !== t3 || $[19] !== t7) {
    t8 = <div className={t1} onClick={t2}>{t3}{t7}</div>;
    $[16] = t1;
    $[17] = t2;
    $[18] = t3;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== dropdownItems || $[22] !== open) {
    t9 = open && <SideMenuDropdownPanel dropdownItems={dropdownItems} />;
    $[21] = dropdownItems;
    $[22] = open;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  let t10;
  if ($[24] !== t8 || $[25] !== t9) {
    t10 = <div>{t8}{t9}</div>;
    $[24] = t8;
    $[25] = t9;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  return t10;
};
function SideMenuSubItem(item) {
  const $ = _c(9);
  if (!item.shouldRender) {
    return null;
  }
  let T0;
  let t0;
  if ($[0] !== item.href || $[1] !== item.isActive) {
    const isActive = item.isActive(item.href);
    T0 = LinkWithoutPrefetch;
    t0 = getSubItemClass(isActive);
    $[0] = item.href;
    $[1] = item.isActive;
    $[2] = T0;
    $[3] = t0;
  } else {
    T0 = $[2];
    t0 = $[3];
  }
  let t1;
  if ($[4] !== T0 || $[5] !== item.href || $[6] !== item.name || $[7] !== t0) {
    t1 = <T0 className={t0} href={item.href}>{item.name}</T0>;
    $[4] = T0;
    $[5] = item.href;
    $[6] = item.name;
    $[7] = t0;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  return t1;
}
const getSubItemClass = (isActive: boolean) => `${isActive ? 'text-brand-primary' : 'text-text-primary'} mb-1 hover:text-brand-primary text-[15px] font-light flex items-center justify-between w-full main-transition-colors`;
function _temp2(item) {
  if (isFlatMenuItem(item)) {
    return <SideMenuSubItem key={item.name} {...item} />;
  } else {
    return <SideSubMenu key={item.name} {...item} />;
  }
}
function _temp3(prev) {
  return !prev;
}